
<template> 
    <v-layout row>
        <v-flex xs12 sm12 >
            <v-card>
                <v-card-title primary-title>
                    <h4><i class="material-icons"> arrow_back </i> <span>Back to events</span></h4>
                </v-card-title>
                <v-card-title primary-title>
                    <h2 class="big-title">{{eventDetail.title}}</h2>  
                </v-card-title>
                <v-card-title>
                    <span class="grey--text">
                        <img src="../../../assets/calendar.png" alt="" srcset="" class="h15 padR10">
                        June,27 
                    </span>
                    
                    <span class="grey--text padL12"> 
                        <img src="../../../assets/clock.png" alt="" srcset="" class="h15 "> 
                        <span class="padL12" v-if="eventDetail.items">{{eventDetail.items[0]['stime']}} -  {{eventDetail.items[0]['etime']}}</span>
                    </span>

                    <span class="grey--text padL12">
                        <img src="../../../assets/placeholder.png" alt="" srcset="" class="h15">
                            {{eventDetail.city}}, {{eventDetail.state}}
                    </span>
                </v-card-title> 
                <v-layout row>
                    <v-flex xs12 sm12 md12 lg12>
                        <v-flex xs12 sm12 md6 lg6 class="pad15 float-left">
                            <div class="">{{eventDetail.description}}</div> 
                            <div class="pad20 light-blue--text fntSzInitial">
                                Event details
                            </div>
                            <div class="pad10 blue--text bold fntSzInitial full-width"> 
                            <img src="../../../assets/worlwide.png" alt="" srcset="" class="h19 padR10">
                            {{eventDetail.website}}
                            </div>
                            <div class="pad10 blue--text bold  fntSzInitial full-width"> 
                            <img src="../../../assets/facebook.png" alt="" srcset="" class="h19 padR10">
                                {{eventDetail.facebook}}
                            </div>
                            <div class="pad10 blue--text bold fntSzInitial full-width">
                            <img src="../../../assets/mail.png" alt="" srcset="" class="h19 padR10" > 
                                {{eventDetail.email}}
                            </div>
                            <div class="pad10 blue--text bold fntSzInitial full-width">
                            <img src="../../../assets/phone-call.png" alt="" srcset="" class="h19 padR10" > 
                                {{eventDetail.contactPhone}}
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md6 lg6 class="pad15 float-right full-width">
                            <GmapMap :center="latlong" :zoom="7" map-type-id="terrain" class="h300" :style="{width: windowWidth}">
                                <GmapMarker
                                    :key="index"
                                    v-for="(m, index) in markers"
                                    :position="m.position"
                                    :clickable="true"
                                    :draggable="true"
                                    @click="center=m.position"
                                />
                            </GmapMap>
                        </v-flex>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs6 sm6>
                        <div class="pad15 light-blue--text fntSzInitial">
                        65 members wiil go
                        </div>
                    </v-flex>
                    <v-flex xs6 sm6>
                        <div class="text-right">
                            <v-btn color="warning">I WILL GO!</v-btn>
                        </div>
                    </v-flex>
                </v-layout>
             
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import EventService from "@/services/db/EventService.js";
    import CONSTANT from "@/services/Constant.js";
    import Utils from "@/services/Utils.js"; 
    import axios from "axios";
    export default {
        name: "Events-Detail",
        props: ["id"],
        data() {
            return {

                isEditMode: false,
                center: { lat: 45.508, lng: -73.587 },
                markers: [],
                places: [],
                latlong: {lat:0,lng:0},
                currentPlace: null,
                eventDetail: {},
                windowHeight: 0,
                windowWidth: '300px',
            };
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.windowHeight = window.innerHeight;
                    this.windowWidth = window.innerWidth + 'px';
                });
            })
        },
        computed: {
            /*
            * Method to check that request is authenticated or not
            */
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            }
        },
        created() {
            // this.id = "02797b37-403d-05d5e6bb97f1";
            this.loadEventById(this.id);

            },

            methods: {

                // --------------------
                // Method to load existing event by id
                // --------------------
                loadEventById(id) {
                    EventService.getEventById(id, event => {
                        this.eventDetail = Object.assign({}, event); 
                        if(event){
                            var apiName = 'https://api.opencagedata.com/geocode/v1/json?q='+event['address1']+', '+event['city']+', '+event['state']+', '+event['zip']+'&key=0f58989b7a774868bb8d5be5aa63e72d';
                                axios
                                    .get(apiName)
                                    .then(response => {
                                        var response1 = JSON.parse(JSON.stringify(response));
                                        
                                        this.latlong.lat = parseFloat(response1.data.results[0].geometry.lat);
                                        this.latlong.lng = parseFloat(response1.data.results[0].geometry.lng);
                                        // this.latlong = {lat:10,lng:10}
                                    }
                                )
                        } else {
                            this.$store.commit("setAlert", {
                                isAlertError: true,
                                message: CONSTANT.MESSAGES.EVENT.GETBY_ID_FAIL
                            });
                            setTimeout(() => {
                                
                            }, 1500);
                        }
                    });
                },
                // goto event page
                gotoEvents(){
                    this.$router.push('/events');
                },

                /*
                * Method to redirect specific path
                */
                goToPath(path) {
                    this.$router.push(path);
                }
                
            }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
    h3 {
        margin: 40px 0 0;
    }
    .vue-map-container{
        /* float: right; */
        margin: 0 auto;
        width: 100px;
        /* max-width: 300px; */
        position: relative;
    }
    .vue-map-container .v-map{
        position: static;
    }
</style>
